// Real Bac à jeux brand assets supplied by the client.
// Update these paths if you replace the images via your CDN / storage.

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_jeux-ambiance-hub/artifacts/j4rfdikf_Whimsical%20Logo%20with%20Pastel%20Contrast%20for%20bac%20%C3%A0%20jeux.pdf.png";

export const BOX_RECTO_URL =
  "https://customer-assets.emergentagent.com/job_06e7e6bc-6ff4-45b8-a0aa-3a62f74d627e/artifacts/jny1nllf_ChatGPT%20Image%2025%20mai%202026%2C%2023_32_57.png";

export const BOX_VERSO_URL =
  "https://customer-assets.emergentagent.com/job_jeux-ambiance-hub/artifacts/htg9izon_ChatGPT%20Image%2024%20mai%202026%2C%2023_12_08.png";

export const FOUNDER_BENJAMIN_URL =
  "https://customer-assets.emergentagent.com/job_jeux-ambiance-hub/artifacts/b24gksnx_image.png";

export const FOUNDER_CHRISTOPHE_URL =
  "https://customer-assets.emergentagent.com/job_jeux-ambiance-hub/artifacts/t1fifqaa_image.png";

export const FOLLOW_ME_CARDS = [
  {
    url: "https://customer-assets.emergentagent.com/job_jeux-ambiance-hub/artifacts/2qle86e4_1.png",
    label: "Hashtags +5000",
    type: "Bonus",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_jeux-ambiance-hub/artifacts/325friwb_105.png",
    label: "Shadowban",
    type: "Action",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_jeux-ambiance-hub/artifacts/oehqa29a_127.png",
    label: "Raid",
    type: "Action",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_jeux-ambiance-hub/artifacts/p9rxzqa6_129.png",
    label: "Sponsor — Tema",
    type: "Sponsor",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_jeux-ambiance-hub/artifacts/20y4og49_141.png",
    label: "Achat de Followers",
    type: "Achat",
  },
];
